import { MutationTree } from 'vuex';
import { State } from '@/manager/employee/store/state';

export const mutations: MutationTree<State> = {
    setEmployeeList: (state, payload) => {
        state.list = payload;
    },
};
